<div class="page-content" [class.embedded-config]="embedded">
  <app-equipamentos-nav *ngIf="!embedded" />

  <section class="config-hero">
    <div>
      <span class="eyebrow">Configuração do inventário</span>
      <h2>Tipos e propriedades de equipamento</h2>
      <p>Defina os campos, listas, marcas e modelos que aparecem no registo de cada tipo.</p>
    </div>
    <button type="button" class="btn-primary" (click)="abrirNovoTipo()">
      <i class="pi pi-plus"></i> Novo tipo
    </button>
  </section>

  <section class="type-selector-card" *ngIf="!embedded">
    <div class="selector-copy">
      <span class="selector-icon"><i [class]="tipoSelecionado?.icon || 'pi pi-box'"></i></span>
      <div>
        <strong>Tipo em configuração</strong>
        <span>As alterações abaixo ficam associadas apenas ao tipo selecionado.</span>
      </div>
    </div>
    <p-select
      [(ngModel)]="selectedTipoId"
      [options]="tipos"
      optionLabel="designacao"
      optionValue="id"
      [loading]="loading"
      placeholder="Selecionar tipo"
      styleClass="type-select"
      (onChange)="onTipoChange($event.value)"
    />
  </section>

  <div class="config-tabs" *ngIf="selectedTipoId">
    <button
      type="button"
      [class.active]="activeSection === 'propriedades'"
      (click)="activeSection = 'propriedades'"
    >
      <i class="pi pi-sliders-h"></i>
      Propriedades
      <span>{{ propriedades.length }}</span>
    </button>
    <button
      type="button"
      [class.active]="activeSection === 'catalogo'"
      (click)="activeSection = 'catalogo'"
    >
      <i class="pi pi-book"></i>
      Marcas e modelos
      <span>{{ marcas.length }}</span>
    </button>
  </div>

  <section class="config-panel" *ngIf="selectedTipoId && activeSection === 'propriedades'">
    <header class="panel-header">
      <div>
        <h3>Propriedades de {{ tipoSelecionado?.designacao?.trim() }}</h3>
        <p>Os campos ativos são montados dinamicamente ao criar ou editar um equipamento.</p>
      </div>
      <button type="button" class="btn-primary" (click)="abrirNovaPropriedade()">
        <i class="pi pi-plus"></i> Adicionar propriedade
      </button>
    </header>

    <div class="loading-list" *ngIf="loadingPropriedades">
      <p-skeleton height="66px" *ngFor="let item of [1, 2, 3]" />
    </div>

    <div class="property-list" *ngIf="!loadingPropriedades && propriedades.length">
      <article class="property-row" *ngFor="let prop of propriedades">
        <span class="property-icon"><i [class]="prop.icon || 'pi pi-list'"></i></span>
        <div class="property-main">
          <div class="property-title">
            <strong>{{ formatarNome(prop.nome) }}</strong>
            <span class="type-pill" [class.list-pill]="isLista(prop)">
              {{ prop.tipoDadoDescricao || (isLista(prop) ? 'Lista' : 'Tipo ' + prop.tipoDado) }}
            </span>
            <span class="status-pill" [class.off]="prop.ativo === false">
              {{ prop.ativo === false ? 'Inativa' : 'Ativa' }}
            </span>
          </div>
          <div class="property-meta">
            <span><i class="pi pi-code"></i> {{ prop.nome }}</span>
            <span *ngIf="prop.sourceKey"><i class="pi pi-database"></i> {{ prop.sourceKey }}</span>
            <span *ngIf="prop.dependeDe"><i class="pi pi-link"></i> depende de {{ prop.dependeDe }}</span>
            <span *ngIf="isLista(prop)"><i class="pi pi-list"></i> opções próprias</span>
          </div>
        </div>
        <div class="property-actions">
          <button
            *ngIf="isLista(prop)"
            type="button"
            class="btn-soft"
            (click)="abrirOpcoes(prop)"
          >
            <i class="pi pi-list"></i> Opções
          </button>
          <button
            type="button"
            class="icon-button"
            pTooltip="Editar configuração"
            tooltipPosition="top"
            (click)="editarPropriedade(prop)"
          >
            <i class="pi pi-pencil"></i>
          </button>
        </div>
      </article>
    </div>

    <div class="empty-state" *ngIf="!loadingPropriedades && !propriedades.length">
      <i class="pi pi-sliders-h"></i>
      <strong>Este tipo ainda não tem propriedades</strong>
      <span>Adicione o primeiro campo para começar a montar o formulário.</span>
      <button type="button" class="btn-soft" (click)="abrirNovaPropriedade()">
        Adicionar propriedade
      </button>
    </div>
  </section>

  <section class="config-panel" *ngIf="selectedTipoId && activeSection === 'catalogo'">
    <header class="panel-header">
      <div>
        <h3>Catálogo de {{ tipoSelecionado?.designacao?.trim() }}</h3>
        <p>As marcas são separadas por categoria; cada modelo pertence à marca selecionada.</p>
      </div>
    </header>

    <div class="catalog-grid">
      <div class="catalog-column">
        <div class="catalog-heading">
          <span><i class="pi pi-bookmark"></i> Marcas</span>
          <small>{{ marcas.length }} registadas</small>
        </div>
        <div class="inline-create">
          <input
            pInputText
            [value]="novaMarca"
            (input)="novaMarca = $any($event.target).value"
            placeholder="Nome da nova marca"
            (keyup.enter)="adicionarMarca()"
          />
          <button type="button" class="btn-primary square" [disabled]="saving || !novaMarca.trim()" (click)="adicionarMarca()">
            <i class="pi pi-plus"></i>
          </button>
        </div>
        <div class="catalog-list" [class.is-loading]="loadingCatalogo">
          <button
            type="button"
            *ngFor="let marca of marcas"
            [class.selected]="selectedMarcaId === marca.value"
            (click)="onMarcaChange(marca.value)"
          >
            <span><i class="pi pi-bookmark"></i> {{ marca.label }}</span>
            <i class="pi pi-chevron-right"></i>
          </button>
          <div class="mini-empty" *ngIf="!loadingCatalogo && !marcas.length">Sem marcas configuradas.</div>
        </div>
      </div>

      <div class="catalog-column">
        <div class="catalog-heading">
          <span><i class="pi pi-box"></i> Modelos</span>
          <small>{{ selectedMarcaId ? modelos.length + ' registados' : 'Selecione uma marca' }}</small>
        </div>
        <div class="inline-create">
          <input
            pInputText
            [value]="novoModelo"
            (input)="novoModelo = $any($event.target).value"
            placeholder="Nome do novo modelo"
            [disabled]="!selectedMarcaId"
            (keyup.enter)="adicionarModelo()"
          />
          <button type="button" class="btn-primary square" [disabled]="saving || !selectedMarcaId || !novoModelo.trim()" (click)="adicionarModelo()">
            <i class="pi pi-plus"></i>
          </button>
        </div>
        <div class="model-grid">
          <span *ngFor="let modelo of modelos"><i class="pi pi-box"></i> {{ modelo.label }}</span>
        </div>
        <div class="mini-empty tall" *ngIf="selectedMarcaId && !loadingCatalogo && !modelos.length">
          Ainda não existem modelos para esta marca.
        </div>
        <div class="mini-empty tall" *ngIf="!selectedMarcaId">
          Selecione uma marca à esquerda para gerir os modelos.
        </div>
      </div>
    </div>
  </section>

  <div class="empty-state page-empty" *ngIf="!loading && !tipos.length">
    <i class="pi pi-box"></i>
    <strong>Nenhum tipo de equipamento configurado</strong>
    <button type="button" class="btn-primary" (click)="abrirNovoTipo()">Criar primeiro tipo</button>
  </div>
</div>

<p-dialog
  [(visible)]="propriedadeDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '720px', maxWidth: 'calc(100vw - 32px)' }"
  [header]="editingPropriedadeId ? 'Editar propriedade' : 'Nova propriedade'"
  appendTo="body"
  styleClass="equipment-config-dialog"
>
  <form [formGroup]="propriedadeForm" class="dialog-form">
    <div class="field span-2">
      <label>Nome do campo <span>*</span></label>
      <input pInputText formControlName="nome" placeholder="Ex.: Categoria do equipamento" />
      <small>O nome será guardado no formato CATEGORIA_DO_EQUIPAMENTO.</small>
    </div>
    <div class="field">
      <label>Tipo de dado <span>*</span></label>
      <p-select formControlName="tipoDado" [options]="tiposDado" optionLabel="label" optionValue="value" styleClass="w-full" />
    </div>
    <div class="field">
      <label>Ícone PrimeIcons</label>
      <input pInputText formControlName="icon" placeholder="pi pi-list" />
    </div>

    <div class="list-callout span-2" *ngIf="isListaForm">
      <i class="pi pi-list"></i>
      <div>
        <strong>Lista gerida pela propriedade</strong>
        <span>Depois de guardar, use “Opções” para adicionar os valores deste dropdown.</span>
      </div>
    </div>

    <ng-container *ngIf="!isListaForm">
      <div class="field">
        <label>Fonte de dados</label>
        <p-select formControlName="sourceKey" [options]="fontes" optionLabel="label" optionValue="value" [showClear]="true" placeholder="Sem fonte" styleClass="w-full" />
      </div>
      <div class="field">
        <label>Depende de</label>
        <p-select formControlName="dependeDe" [options]="propriedadesDependencia" optionLabel="label" optionValue="value" [showClear]="true" placeholder="Sem dependência" styleClass="w-full" />
      </div>
      <div class="field span-2">
        <label>Endpoint de referência</label>
        <input pInputText formControlName="endpointReferencia" placeholder="GET /api/..." />
      </div>
      <div class="field">
        <label>Campo label</label>
        <input pInputText formControlName="campoLabel" placeholder="nome" />
      </div>
      <div class="field">
        <label>Campo value</label>
        <input pInputText formControlName="campoValue" placeholder="id" />
      </div>
    </ng-container>

    <div class="field">
      <label>Formato</label>
      <input pInputText formControlName="formato" placeholder="Opcional" />
    </div>
    <div class="checks">
      <label><input type="checkbox" formControlName="ativo" /> Propriedade ativa</label>
      <label><input type="checkbox" formControlName="cache" /> Usar cache da fonte</label>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="dialog-actions">
      <button type="button" class="btn-secondary" [disabled]="saving" (click)="propriedadeDialog = false">Cancelar</button>
      <button type="button" class="btn-primary" [disabled]="saving" (click)="guardarPropriedade()">
        <i [class]="saving ? 'pi pi-spin pi-spinner' : 'pi pi-save'"></i>
        {{ saving ? 'A guardar...' : 'Guardar propriedade' }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="opcaoDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '560px', maxWidth: 'calc(100vw - 32px)' }"
  [header]="'Opções · ' + formatarNome(opcaoPropriedade?.nome || '')"
  appendTo="body"
  styleClass="equipment-config-dialog"
>
  <div class="inline-create option-create">
    <input pInputText [value]="novaOpcao" (input)="novaOpcao = $any($event.target).value" placeholder="Nova opção" (keyup.enter)="adicionarOpcao()" />
    <button type="button" class="btn-primary" [disabled]="saving || !novaOpcao.trim()" (click)="adicionarOpcao()">
      <i class="pi pi-plus"></i> Adicionar
    </button>
  </div>
  <div class="option-list">
    <p-skeleton height="40px" *ngIf="loadingOpcoes" />
    <div *ngFor="let opcao of opcoes">
      <span><i class="pi pi-check-circle"></i> {{ opcao.valor }}</span>
      <small>#{{ opcao.id }}</small>
    </div>
    <div class="mini-empty" *ngIf="!loadingOpcoes && !opcoes.length">Ainda não existem opções nesta lista.</div>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="tipoDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '560px', maxWidth: 'calc(100vw - 32px)' }"
  header="Novo tipo de equipamento"
  appendTo="body"
  styleClass="equipment-config-dialog"
>
  <form [formGroup]="tipoForm" class="dialog-form single">
    <div class="field">
      <label>Designação <span>*</span></label>
      <input pInputText formControlName="designacao" placeholder="Ex.: Equipamento eletrónico" />
    </div>
    <div class="field">
      <label>Categoria <span>*</span></label>
      <p-select formControlName="idCategoriaEquipamento" [options]="categorias" optionLabel="designacao" optionValue="id" placeholder="Selecionar categoria" styleClass="w-full" />
    </div>
    <div class="field">
      <label>Ícone PrimeIcons</label>
      <input pInputText formControlName="icon" placeholder="pi pi-box" />
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="dialog-actions">
      <button type="button" class="btn-secondary" [disabled]="saving" (click)="tipoDialog = false">Cancelar</button>
      <button type="button" class="btn-primary" [disabled]="saving" (click)="guardarTipo()">
        <i [class]="saving ? 'pi pi-spin pi-spinner' : 'pi pi-plus'"></i>
        {{ saving ? 'A guardar...' : 'Criar tipo' }}
      </button>
    </div>
  </ng-template>
</p-dialog>
